import { FC } from 'react';
import { TPointSummary } from '../../../mapTypes';
import { formatValueAsString } from '../../../../../utils/helpers';

interface IStoppageEventPopupContentProps {
  info: TPointSummary;
  options: Intl.NumberFormatOptions;
}

const StoppageEventPopupContent: FC<IStoppageEventPopupContentProps> = ({ info, options }) => (
  <>
    <div>
      <span className="font-bold">Activity : </span>
      <span>{info?.name}</span>
    </div>
    <div>
      <span className="font-bold">Start Time : </span>
      <span>{new Date(info?.startTime!).toLocaleString()}</span>
    </div>
    <div>
      <span className="font-bold">End Time : </span>
      <span>{new Date(info?.endTime!).toLocaleString()}</span>
    </div>
    <div>
      <span className="font-bold">Total Time (Days) : </span>
      <span>{formatValueAsString(info?.totalTimeInPort, options, '', '', ' ')}</span>
    </div>
  </>
);

export default StoppageEventPopupContent;
